import { EntityReference } from '../../core/entities/shared/entity-reference.entity';
import { FormOptions } from './base.form-options';

export class ShoppingItemFormOptions extends FormOptions {
  locations: EntityReference[] = [];
}
